import {
    DpChartWidgetGroup,
    DpSinclairAverageWaitTimeChartWidget,
    DpSinclairGeneratedItemsChartWidget
} from '@docpath/webcomponents';

export function buildHomeChartWidgetGroups(isCloudMode: boolean): DpChartWidgetGroup[] {
    return [
        new DpChartWidgetGroup({
            name: 'home',
            widgets: [
                new DpSinclairGeneratedItemsChartWidget(isCloudMode),
                new DpSinclairAverageWaitTimeChartWidget()
            ]
        })
    ];
}